import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";

import { createAvtarName, hasImage } from "../../../../../utils";
import { updateBoard } from "../../../../../sevices/apiBoards";
import { useBoardUsers } from "../../../../../utils/reactQuery/users";
import Avatar from "../../../../../components/Avatar";
import Loader from "../../../../../components/Loader";
import CustomMenu from "../../../../../components/Menu";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useMutate from "../../../../../hooks/useMutate";

function ListBoardUser({ anchorEl, open, handleClose, id, params }) {
  const queryClient = useQueryClient();
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);

  const { isLoading, error, data } = useBoardUsers(id);

  useEffect(() => {
    if (data?.data?.data?.responseData) {
      setUsers(data.data.data.responseData);
    }
  }, [data, isLoading, id]);

  const sortedUsers = useMemo(() => {
    return users.sort((a, b) => a.username.localeCompare(b.username));
  }, [users]);

  const { mutate: assignBoardMutate } = useMutate(updateBoard,["boards"], () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`boardName`, id],
      });
      setLoading(false);
      setOpenDialog(false);
      handleClose();
    },
    () => {
      setLoading(false);
      setOpenDialog(false);
    });

  const handleChangeBoardOwner = useCallback(() => {
    setLoading(true);
    assignBoardMutate({
      board_id: id,
      data: { owner_user_id: userId.user_id },
    });
  }, [assignBoardMutate, id, userId]);

  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
  }, []);

  const handleSelectBoardOwner = useCallback((user) => {
    setOpenDialog(true);
    setUserId(user);
  }, []);

  return (
    <>
      {openDialog && (
        <FormDialog
          open={openDialog}
          handleClose={handleCloseDialog}
          handleSubmit={handleChangeBoardOwner}
          loading={loading}
          buttonTxt={"Assign"}
          title={"Confirmation: Assign Board Owner"}
          alignActions={"center"}
          cancelBtn={true}
          width={500}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2 ">
            {`Are you sure to assign ${userId?.username} as Board Owner?`}
          </Typography>
        </FormDialog>
      )}
      <CustomMenu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="assign-board-owner-list"
      >
        {isLoading && (
          <div className="loader-center">
            <Loader color={"black"} />
          </div>
        )}
        {sortedUsers.map((el) => {
          return (
            <CustomMenuItem
              key={`user-avtar-dropdown-admin-assign-${el?.user_id}`}
              onClick={() => handleSelectBoardOwner(el)}
              className={
                params?.row?.board_owner_id == el?.user_id
                  ? "active-assign"
                  : ""
              }
            >
              <Avatar
                key={`user-avtar-${el?.user_id}`}
                username={el?.username}
                user_image={el?.user_image}
                title={el?.username}
                className="user-avtar-dropdown user-avatar mr-8"
                style={
                  !hasImage(el?.user_image) && {
                    bgcolor: el?.profile_color?.background,
                    color: el?.profile_color?.text,
                  }
                }
              >
                {createAvtarName(el?.username)}
              </Avatar>

              {el?.username}
            </CustomMenuItem>
          );
        })}
      </CustomMenu>
    </>
  );
}

const isChangeListBoardUser = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.board_owner_id === nextProps?.params?.row?.board_owner_id
  );
};

export default React.memo(ListBoardUser,isChangeListBoardUser);
